/**
 * Navegação do site.
 *
 * O site é uma página única com seções ancoradas — a mesma estrutura do site
 * anterior da Dra. Carla Rangel. "Blog" é a única página de conteúdo fora dela;
 * os documentos legais ficam no rodapé.
 */

export type AncoraNav = {
  id: string;
  label: string;
  /** Rótulo curto usado na barra do topo, como no site anterior. */
  curto: string;
};

export type ItemNav = { rotulo: string; href: string };

export const NAV_ANCORAS: AncoraNav[] = [
  { id: "areas", label: "Áreas de atuação", curto: "Áreas" },
  { id: "sobre", label: "Sobre", curto: "Sobre" },
  { id: "atendimento", label: "Atendimento", curto: "Atendimento" },
  { id: "depoimentos", label: "Depoimentos", curto: "Depoimentos" },
  { id: "faq", label: "Perguntas frequentes", curto: "FAQ" },
  { id: "contato", label: "Contato", curto: "Contato" },
];

export const NAV_PAGINAS: ItemNav[] = [{ rotulo: "Blog", href: "/blog" }];

export const NAV_LEGAL: ItemNav[] = [
  { rotulo: "Política de Privacidade", href: "/politica-de-privacidade" },
  { rotulo: "Política de Cookies", href: "/politica-de-cookies" },
];

/** Mensagem que abre a conversa no WhatsApp — usada em todos os botões. */
export const MENSAGEM_WHATSAPP =
  "Olá, Dra. Carla! Preciso de orientação jurídica e gostaria de conversar sobre meu caso.";
